import { create } from 'zustand'

let _nextId = 0

export interface ToastOptions {
  title: string
  description?: string
  variant?: 'default' | 'destructive'
}

interface ToastItem extends ToastOptions {
  id: number
}

interface ToastState {
  toasts: ToastItem[]
  addToast: (opts: ToastOptions) => void
  removeToast: (id: number) => void
}

export const useToastStore = create<ToastState>()((set) => ({
  toasts: [],
  addToast: (opts) => {
    const id = ++_nextId
    set((s) => ({ toasts: [...s.toasts, { id, ...opts }] }))
    setTimeout(() => {
      set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }))
    }, 4000)
  },
  removeToast: (id) =>
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}))

export function useToast() {
  const addToast = useToastStore((s) => s.addToast)
  return { toast: addToast }
}
